import {
  LOAD_BOOKING_LIST,
  LOAD_BOOKING_LIST_SUCCESS,
  LOAD_BOOKING_LIST_ERROR,
  RESET_BOOKING_LIST,
} from '../type';
import update from 'immutability-helper';
import { initialState } from './initialize-state';
import { handleActions } from 'redux-actions';

const manageBookingReducer = handleActions(
  new Map([
    [
      LOAD_BOOKING_LIST,
      state => {
        return update(state, {
          loadingStatus: {
            bookingListLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_BOOKING_LIST_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            bookingListLoading: { $set: false },
          },
          bookingList: {
            $set: action.payload,
          },
        });
      },
    ],
    [
      LOAD_BOOKING_LIST_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            bookingListLoading: { $set: false },
          },
          bookingList: {
            $set: {
              data: [],
              offset: 0,
              limit: 0,
              total: 0,
            },
          },
          error: { $set: action.payload },
        });
      },
    ],
    //Reset booking list
    [
      RESET_BOOKING_LIST,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            bookingListLoading: { $set: false },
          },
          bookingList: {
            $set: {
              data: [],
              offset: 0,
              limit: 0,
              total: 0,
            },
          },
        });
      },
    ],
  ]),
  initialState,
);
export default manageBookingReducer;
